import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyDown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeyDown)
    this.boundHandleKeyDown = null
  }

  // Focusing the input opens the anchored panel; clicking a scope menu item
  // presets the type through the same path the dropdown uses
  openSearch(scopeType = null) {
    const searchInput = document.querySelector('#mainSearchInput')
    if (!searchInput) return

    if (scopeType) {
      const scopeItem = document.querySelector(`.header__search-scope [data-scope-type='${scopeType}']`)
      if (scopeItem) scopeItem.click()
    }

    searchInput.focus()
  }

  handleKeyDown(event) {
    // Skip if user is typing in an input or textarea
    if (this.isUserTyping()) return

    // Open search
    if (event.key === '/' && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey) {
      event.preventDefault()
      this.openSearch()
    }

    // Open advanced search
    if (event.key === '?' && event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey) {
      event.preventDefault()
      const params = new URLSearchParams()
      params.set("back_url", window.location.href)

      const searcher = document.querySelector("[data-controller='searcher']")
      if (searcher && searcher.dataset.companyId) {
        params.set("company", searcher.dataset.companyId)
      }

      window.location.href = `/advanced_search${params.toString() ? `?${params}` : ""}`
      return
    }

    // Open search scoped to a specific type
    if (!event.ctrlKey && !event.metaKey && !event.altKey) {
      switch (event.key) {
        case 'p':
        case 'P':
          event.preventDefault()
          this.openSearch('passwords')
          break
        case 'c':
        case 'C':
          event.preventDefault()
          this.openSearch('companies')
          break
        case 'a':
        case 'A':
          event.preventDefault()
          this.openSearch('assets')
          break
        case 'k':
        case 'K':
          event.preventDefault()
          this.openSearch('articles')
          break
        case 'w':
        case 'W':
          event.preventDefault()
          this.openSearch('websites')
          break
        case 'o':
        case 'O':
          event.preventDefault()
          this.openSearch('processes')
          break
      }
    }


    // if CTRL + K, open keyboard shortcuts menu
    if (event.key === '/' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      if (document.querySelector('#keyboard-shortcuts-shortcut')) {
        document.querySelector('#keyboard-shortcuts-shortcut').click()
      }
      return;
    }

    if ((event.key === 'h' || event.key === 'H') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#ai-shortcut')) {
        document.querySelector('#ai-shortcut').click()
      }
      return;
    }

    if ((event.key === 'm' || event.key === 'M') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#add-comment-shortcut')) {
        document.querySelector('#add-comment-shortcut').click()
      }
      return;
    }

    if ((event.key === 'e' || event.key === 'E') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#edit-shortcut')) {
        document.querySelector('#edit-shortcut').click()
      }
      return;
    }

    if ((event.key === 'f' || event.key === 'F') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#favorite-shortcut')) {
        document.querySelector('#favorite-shortcut').click()
      }
      return;
    }

    if (event.key === '[' && !event.ctrlKey && !event.metaKey && !event.altKey) {
      event.preventDefault()
      const toggleButtons = Array.from(document.querySelectorAll('.toggle-pane-button'));
      const visibleButton = toggleButtons.find(button => {
        const style = window.getComputedStyle(button);
        return style.display !== 'none';
      });

      if (visibleButton) {
        visibleButton.click();
      }
      return;
    }

    if (event.key === ']' && !event.ctrlKey && !event.metaKey && !event.altKey) {
      event.preventDefault()
      const visibleButton = document.querySelector('.cpanel__switch')

      if (visibleButton) {
        visibleButton.click();
      }
      return;
    }
  }

  isUserTyping() {
    const activeElement = document.activeElement
    if (!activeElement) return false

    const tagName = activeElement.tagName
    if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tagName)) return true

    return !!activeElement.closest('.tiptap')
  }
}
